export default {
    topomap: {
        key: 'topomap',
        name: 'ESRI World Topomap',
        type: 'wmts',
        options: {
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
            maxNativeZoom: 16
        }
    },
    imagery: {
        key: 'imagery',
        name: 'ESRI World Imagery',
        type: 'wmts',
        options: {
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            maxNativeZoom: 17
        }
    },
    osm: {
        key: 'osm',
        name: 'Open Street Map',
        type: 'wmts',
        options: {
            url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png'
        }
    },
    esriCanvas: {
        key: 'esriCanvas',
        name: 'ESRI Grey Canvas',
        type: 'wmts',
        options: {
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
            maxNativeZoom: 16
        }
    },
    cartoDark: {
        key: 'cartoDark',
        name: 'CartoDB - dark',
        type: 'wmts',
        options: {
            url:
                'https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png',
        },
    },
}